<template>
  <PresentacionListView action-buttons-name="PresentacionUpdateListActionButtons"
                        path="update-presentations"
                        filter-path="filters/update-presentations"
                        toolbar-title="Actualizaciones"
                        search-text="Buscar por fecha (YYYY-MM-DD) o descripción"
                        :second-column="secondColumn"
                        :descripcion="descriptionColumn"
                        :initial-properties="properties"
                        :initial-headers="headers">
    <v-btn light @click="goDraft"  color='rgb(255 214 0)' class="draft-button" v-if="$store.getters.hasDraftInProgress">
      <v-icon  color="black" class="icon-build">error_outline</v-icon>
      <span>Actualización en curso</span>
    </v-btn>
  </PresentacionListView>
</template>

<script>
import PresentacionListView from '../../presentacion/views/PresentacionListView'

const CLUB_INDEX_IN_TABLE = 4

export default {
  components: {
    PresentacionListView
  },

  data () {
    return {
      secondColumn: { text: 'Fecha de presentación', value: 'modified' },
      descriptionColumn: { text: 'Descripción', 'align': 'left', sortable: false, value: 'descripcion' },
      properties: ['nombre', 'descripcion', 'modified', 'estado']
    }
  },

  methods: {
    goDraft () {
      this.$router.push({ name: 'draft' })
    }
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Nombre', align: 'left', value: 'nombre', sortable: false },
        this.descriptionColumn,
        this.secondColumn,
        { text: 'Estado', value: 'status', filterField: true },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(CLUB_INDEX_IN_TABLE, 0, { text: 'Club', value: 'club', filterField: true })
      }
      return headers
    }
  }
}
</script>

<style scoped>
.draft-button {
  margin-top: 0.8em;
  margin-left: 1em;
}
.icon-build {
  margin-right: 0.4em;
}
</style>
